"use client";

export default function Booking() {
  return <section id="appointmentbooking" data-nav="light" className="relative w-full py-20 overflow-hidden !bg-[rgba(66,150,154,1)] md:py-28 lg:py-32">
            <div className="absolute inset-0 pointer-events-none -z-10 flex items-center justify-center overflow-hidden">
                <div className="absolute top-24 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-accent/25 rounded-full blur-3xl" />
                <div className="absolute bottom-24 right-10 w-[450px] h-[450px] bg-accent/15 rounded-full blur-3xl" />
            </div>

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
                <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-default font-bold text-foreground tracking-tight leading-tight mb-4">
                        <span className="text-secondary">Jetzt Termine für Probesitzen und Folgehandlung buchen!</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-6xl mx-auto px-4 py-8">
                    {/* Probetermine (Links) */}
                    <div className="flex flex-col items-center bg-primary/10 p-6 rounded-2xl">
                        <h3 className="text-xl font-bold mb-4 text-foreground">Probetermin buchen</h3>
                        <iframe src="https://zeeg.me/bodyconcept-by-linda/probesitzung?embed=true" className="w-full rounded-xl border-0" style={{
            minWidth: "320px",
            height: "780px"
          }} title="Probetermin buchen" />
                    </div>

                    {/* Folgetermine (Rechts) mit dem neuen korrekten Event-Typ */}
                    <div className="flex flex-col items-center bg-primary/10 p-6 rounded-2xl">
                        <h3 className="text-xl font-bold mb-4 text-foreground">Folgetermin buchen</h3>
                        <iframe src="https://zeeg.me/bodyconcept-by-linda/folgesitzung-beckenbodenstuhl?embed=true" className="w-full rounded-xl border-0" style={{
            minWidth: "320px",
            height: "780px"
          }} title="Folgetermin buchen" />
                    </div>
                </div>
            </div>
        </section>;
}